import React, { MouseEventHandler, useEffect, useState } from "react";
import cn from "classnames";
import styled from "styled-components";

interface IBottomProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  itemList: string[];
}

const SelectItem = (props: IBottomProps) => {
  return (
    <>
      {props.itemList.map((data, value) => {
        return (
          <li key={value}>
            <SortItemSet
              // className={cn({ selected: i === activeSort })}
              onClick={(e) => {
                props.onClick(e);
              }}
            >
              {data}
            </SortItemSet>
          </li>
        );
      })}
    </>
  );
};

const SortItemSet = styled.button`
  width: 100%;
  padding: 30px 0;
  border: none;
  background: none;
  color: #7f7f7f;
  font-size: 25px;
  font-family: "Roboto";
  font-weight: 500;
  &.selected {
    color: ${({ theme }) => theme.color.subMain};
  }
`;

export default SelectItem;
